import React from 'react';
import { Route, Routes } from 'react-router-dom'; // Import Route and Routes
import './App.css';
import Homepage from './Pages/Homepage';
import About from './Pages/About';
import Blog from './Pages/Blog';
import BlogDetail from './Pages/BlogDetail';
import OurServices from './Pages/OurServices';
import ServiceDetail from './Pages/ServiceDetail';
import Influencers from './Pages/Influencers';
import Contactus from './Pages/Contactus';
import UpSkill from './Pages/UpSkill';
import AdminLogin from './Pages/AdminLogin';
import AdminHomepage from './Pages/AdminHomepage';
import InfluencerLogin from './Components/Influencer/InfluencerLogin';
import InfluencerPaymentCallback from './Pages/InfluencerPaymentCallback';
import EmailTestAll from './Pages/EmailTestAll';
import CreateTestInfluencer from './Pages/CreateTestInfluencer';
import ScrollToTop from './Components/ScrollToTop';
import Homepage2 from './Pages/Homepage2';
import ContactHero from './Pages/ContactHero';

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        {/* Homepage2 is now the primary homepage */}
        <Route path="/" element={<Homepage2 />} />
        {/* <Route path="/" element={<Homepage />} /> */}
        {/* <Route path="/home2" element={<Homepage2 />} /> */}
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/services" element={<OurServices />} />
        <Route path="/services/:serviceName" element={<ServiceDetail />} />
        <Route path="/influencer" element={<Influencers />} />
        <Route path="/influencer/payment-callback" element={<InfluencerPaymentCallback/>} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/contact-hero" element={<ContactHero />} />
        <Route path="/upskill" element={<UpSkill />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/adminhomepage" element={<AdminHomepage/>} />
        <Route path="/email-test-all" element={<EmailTestAll />} />
        <Route path="/create-test-influencer" element={<CreateTestInfluencer />} />

        {/* Add other routes here */}
      </Routes>
    </div>
  );
}

export default App;
